import React from 'react'

export const OrganizationDetail = () => {
    return <div>OrganizationDetail</div>
}
